import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { CacheNamesEnum } from "../../models/shared.model";

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.css'
})
export class TermsAndConditionsComponent implements OnInit {

  termsHtml: string = '';
  constructor(private sharedService: SharedService) {}

  ngOnInit() {
    const cached = this.loadTermsAndConditionsFromCache();

    this.sharedService.shouldUpdateCache().then((shouldUpdate) => {
      if (shouldUpdate || !cached) {
        this.sharedService.getTermsAndConditions().subscribe((response) => {
          if (response.status == 304)
            return;

          if (response?.body.data?.content) {
            this.termsHtml = response.body.data.content;
            localStorage.setItem(CacheNamesEnum.TERMS_AND_CONDITION, JSON.stringify(response.body.data));
          }
        });
      } else {
        if (cached && cached?.content) {
          this.termsHtml = cached.content;
        }
      }
    });
  }

  loadTermsAndConditionsFromCache(): any {
    const termsJson = localStorage.getItem(CacheNamesEnum.TERMS_AND_CONDITION);
    if (!termsJson) {
      return null; // Not cached
    }

    try {
      const terms =  JSON.parse(termsJson);
      if(terms?.content)
        return terms
      return null;
    } catch {
      // Cache corrupted, clear it
      localStorage.removeItem(CacheNamesEnum.TERMS_AND_CONDITION);
      return null;
    }
  }
}
